import {
    easing,
    Slide,
    styled,
    Theme,
    Typography,
    useTheme,
} from "@mui/material";
import React from "react";
import { useAppSelector } from "#store";
import { AppConfig } from "#/config";
import { SrcSpinner } from "@iva/d3-svg-spinner";
import whiteLogo from "#/assets/inode/inode-white.svg";
import blackLogo from "#/assets/inode/inode-black.svg";
import { H3, H4 } from "#common/headings";

const BackgroundPlane = styled(`div`)(({ theme }) => ({
    // minWidth: "100vw",
    width: "100%",
    height: "100%",
    position: "fixed",
    left: 0,
    top: 0,
    // overflowY: "scroll",
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "5.6px 11.2px 11.2px hsl(0deg 0% 0% / 0.33)",
    // transition: theme.transitions.create("all")
}));
const CenteredContent = styled(`div`)({
    position: "absolute",
    textAlign: "center",
    top: "50%",
    left: "50%",
    MozTransform: "translateX(-50%) translateY(-50%)",
    WebkitTransform: "translateX(-50%) translateY(-50%)",
    transform: "translateX(-50%) translateY(-50%)",
});
export const SplashScreen = ({ children }: React.PropsWithChildren<{}>) => {
    const theme: Theme = useTheme();
    const appState = useAppSelector(state => state.environment.state);
    return (
        <>
            <Slide
                in={appState !== "running"}
                // in={true}
                appear={false}
                timeout={250}
                easing={{ exit: easing.easeIn, enter: easing.easeInOut }}
            >
                <BackgroundPlane>
                    <CenteredContent>
                        <H3>{AppConfig.name}</H3>
                        <H4>{appState}&hellip;</H4>
                        <br />
                        <SrcSpinner
                            size={{ height: "20vh", width: "80vw" }}
                            src={
                                theme.palette.mode === "light"
                                    ? whiteLogo
                                    : blackLogo
                            }
                        />
                    </CenteredContent>
                </BackgroundPlane>
            </Slide>
            {appState === "running" ? children : null}
        </>
    );
};
